import ReportBug from '../components/ReportBug/ReportBug';

const ReportBugPage = () => <ReportBug />;

export default ReportBugPage;
